"use client";

import { useEffect } from "react";
import Script from "next/script";

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    if (typeof window !== "undefined" && window.newrelic) {
      try {
        window.newrelic.noticeError(error, {
          type: "globalError",
          digest: error.digest || "unavailable",
        });
      } catch (e) {
        console.warn("Could not log error to NewRelic:", e);
      }
    }
  }, [error]);

  return (
    <html>
      <body>
        <Script src="/scripts/newrelic" />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            fontFamily: "Inter, system-ui, sans-serif",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <h2
              style={{
                fontSize: "1.125rem",
                fontWeight: 600,
                marginBottom: "0.5rem",
              }}
            >
              Something went wrong
            </h2>
            <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>
              We&apos;re working on fixing the problem.
            </p>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                marginTop: "1rem",
                padding: "0.5rem 1rem",
                cursor: "pointer",
                borderRadius: "0.25rem",
                border: "1px solid #d1d5db",
                backgroundColor: "white",
                fontSize: "0.875rem",
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
